import ArrowRb from 'src/assets/icons/arrow-rb.svg?react';
import Bike from 'src/assets/icons/bike.svg?react';
import Google from 'src/assets/icons/google.svg?react';
import Hide from 'src/assets/icons/hide.svg?react';
import Instagram from 'src/assets/icons/instagram.svg?react';
import Logo from 'src/assets/icons/logo.svg?react';
import LogoText from 'src/assets/icons/logo-text.svg?react';
import Music from 'src/assets/icons/music.svg?react';
import Show from 'src/assets/icons/show.svg?react';
import User from 'src/assets/icons/user.svg?react';

export default {
  ArrowRb,
  Bike,
  Google,
  Hide,
  Instagram,
  Logo,
  LogoText,
  Music,
  Show,
  User,
};
